import React from 'react'
import styled from "styled-components/macro"
import { Id } from "incident-code-core"

import { OverlayGradient } from "../../../../components"
import { PlayButton } from "../Player/components/PlayButton"

interface IPreviewProps {
  fullwidth: boolean
  thumbnailUrl? : string
  currentId: Id
  id: Id
  index: number
  uploadId? : number
  handleClick(): void
}


const Preview: React.FC<IPreviewProps> = ({
  fullwidth,
  thumbnailUrl,
  currentId,
  id,
  index,
  uploadId,
  handleClick
}) => (
  <Container fullwidth={fullwidth}>
    <VideoPreview thumbnail={thumbnailUrl} key={index}>
      {currentId === id || (
        <>
          <PlayButton isPlaying={false} sideSize={45} onClick={handleClick} />
          <OverlayGradient />
        </>
      )}
    </VideoPreview>
    <UploadId>{"#"}{uploadId}</UploadId>
  </Container>
)

interface IVideoPreviewProps {
  thumbnail?: string
}

interface IContainerProps {
  fullwidth: boolean
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props: IContainerProps) => props.fullwidth ? '100%' : '30%'};
`

const VideoPreview = styled.div`
  position: relative;
  max-width: 10em;
  height: 20vh;
  background: ${(props: IVideoPreviewProps) => `url(${props.thumbnail})` || "grey"};
  background-position: center center;
  background-size: cover;
  margin-right: 10px;
`

const UploadId = styled.div`
  color: #FFF;
  font-size: 12px
`

export default Preview;
